import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import TaskViewCard from './TaskViewCard';
import { useTaskViews } from '../../../hooks/taskView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TaskViewList = ({
  onboardingKey,
  onTaskGroupClick,
  showDismissedTaskViews = false
}) => {
  const taskViews = useTaskViews(showDismissedTaskViews);
  if (!taskViews || taskViews.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: taskViews.map(({
      viewKey,
      isRecentlyRemoved
    }) => {
      return /*#__PURE__*/_jsx(AccordionTransition, {
        open: !isRecentlyRemoved,
        children: /*#__PURE__*/_jsx(TaskViewCard, {
          onTaskGroupClick: onTaskGroupClick,
          onboardingKey: onboardingKey,
          viewGroupKey: viewKey
        })
      }, viewKey);
    })
  });
};
export default TaskViewList;